import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import EditFileItemModal from "./EditActivity/EditFileItem";
import AddLinkModal from "../CourseBuilder/AddLinkModal";
import CreateShortCoursePage from "../../views/Content/Courses/CourseBuilder/CreateShortCoursePage";
import CourseQuizContainer from "../../views/Content/Courses/CourseBuilder/CourseQuiz";
import CourseSurveyContainer from "../../views/Content/Courses/CourseBuilder/CourseSurvey";

const EditCourseActivity = ({
  open,
  onClose,
  onSave,
  shortCourseTitle,
  versionId,
  shortCourseId
}) => {
  const { item, loading } = useSelector(({ acCourseBuilderState }) => ({
    item: acCourseBuilderState.currentlyEditedActivity,
    loading: acCourseBuilderState.loading
  }));
  if (!open) return null;

  const handlePageUpdate = (_, pageData) => {
    pageData.type = "html";
    onSave(pageData);
  };

  const getEditItemModal = () => {
    if (item.type === "file" && item.contentType === "page") {
      return (
        <CreateShortCoursePage
          open={open}
          onClose={onClose}
          coursePage={item}
          onSubmitNewPage={handlePageUpdate}
          shortCourseTitle={shortCourseTitle}
          shortCourseId={shortCourseId}
        />
      );
    }
    switch (item.type) {
      case "file":
      case "video":
        return (
          <EditFileItemModal
            open={open}
            item={item}
            onClose={onClose}
            onSaveActivity={onSave}
          />
        );
      case "link":
        return (
          <AddLinkModal
            open={open}
            onClose={onClose}
            onAddLink={onSave}
            itemEditing={item}
          />
        );
      case "quiz":
        return (
          <CourseQuizContainer
            open={open}
            onClose={onClose}
            versionId={versionId}
            existingQuizId={item.extendableId.toString()}
            shortCourseId={shortCourseId}
          />
        );
      case "survey":
        return (
          <CourseSurveyContainer
            open={open}
            onClose={onClose}
            versionId={versionId}
            existingSurveyId={item.extendableId.toString()}
            shortCourseId={shortCourseId}
          />
        );
      case "scorm":
        return (
          <EditFileItemModal
            open={open}
            item={item}
            onClose={onClose}
            isScorm={true}
            onSaveActivity={onSave}
          />
        );
      default:
        return;
    }
  };
  return (
    <>
      {loading && <LoadingSpinner />}
      {item && getEditItemModal()}
    </>
  );
};

export default EditCourseActivity;

EditCourseActivity.propTypes = {
  item: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func
};
